// URL search param that carries a magic (login) token
export const MAGIC_TOKEN_QUERY_PARAM = 'magicToken'

// Endpoint that exchanges a magic token for an access token
export const MAGIC_TOKEN_EXCHANGE_PATH = '/auth/magic-tokens/exchange'

// Code carried by the request-interceptor throw that stops a call made with an expired magic-link session
export const MAGIC_SESSION_EXPIRED_CODE = 'MAGIC_SESSION_EXPIRED'
